export default __webpack_public_path__ + "static/media/hexomatic-logo.ba249ecd.svg";